import { format, parseISO, isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// Intervalo de messes para o gráfico de total de tickets por aplicação
const BY_APP_MONTH_WINDOW = 12;

// Fuso horário para o gráfico de total de tickets por aplicação
const TIME_ZONE = 'America/Sao_Paulo';

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  try {
    // Parse a data UTC e converte para o fuso horário local
    const date = parseISO(dateString);
    
    if (!isValid(date)) {
      return 'Data inválida';
    }

    // Formata a data no padrão brasileiro
    return format(date, "dd 'de' MMMM 'de' yyyy 'às' HH:mm", { locale: ptBR });
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return 'Data inválida';
  }
};

function spWallYearMonth(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: 'numeric',
  }).formatToParts(date);
  const y = Number(parts.find((p) => p.type === 'year')?.value);
  const mo = Number(parts.find((p) => p.type === 'month')?.value);
  return { y, mo };
}

function lastDayOfCalendarMonth(year, month1to12) {
  return new Date(year, month1to12, 0).getDate();
}

/** Intervalo [from, to] em YYYY-MM-DD no calendário de São Paulo (alinhado ao backend). */
function getByAppMonthRangeLocalDates(monthCount = BY_APP_MONTH_WINDOW) {
  const { y, mo } = spWallYearMonth();
  const endY = y;
  const endM = mo;
  let startY = endY;
  let startM = endM - (monthCount - 1);
  while (startM < 1) {
    startM += 12;
    startY -= 1;
  }
  const from = `${startY}-${String(startM).padStart(2, '0')}-01`;
  const last = lastDayOfCalendarMonth(endY, endM);
  const to = `${endY}-${String(endM).padStart(2, '0')}-${String(last).padStart(2, '0')}`;
  return { from, to };
}

export { formatDate, spWallYearMonth, lastDayOfCalendarMonth, getByAppMonthRangeLocalDates, BY_APP_MONTH_WINDOW, TIME_ZONE };